import { Popup } from 'semantic-ui-react';
import styled from 'styled-components';

import colors from 'styles/colors';

const pillSize = 26;

export const OdometerTypePill = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: fit-content;
  min-width: ${pillSize}px;
  height: ${pillSize}px;
  border-radius: ${pillSize / 2}px;
  padding: 0 ${pillSize / 2 - 2}px;
  border: 1px solid ${colors.selectorBorder};
  background-color: ${colors.metricsHoverBackground};
  & > *:nth-child(n + 2) {
    margin-left: 5px;
  }
`;

export const OdometerTypePillText = styled.div`
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
`;

export const OdometerPillTooltip = styled(Popup)`
  background-color: ${colors.fleetBlack} !important;
  font-weight: 600 !important;
  font-size: 12px !important;

  & ::before {
    background: ${colors.fleetBlack} !important;
  }
`;

export const InfoLink = styled.a`
  color: ${colors.fleetBlue};
  display: flex;
`;
